const statesOrigin = ['AL', 'AK', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NY', 'NV', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
// "applyType": "create", //申请类型 create-创建 bind-认领
// "bindStatus": "binded" //认领状态 not_bind-未认领 under_review-审核中 approval_fail-审核未通过 binded-已认领


export default {
  state: {
    businessTypes: [{
      value: 'main',
      label: '连锁总店',
    }, {
      value: 'branch',
      label: '连锁分店',
    }, {
      value: 'independent',
      label: '独立商家',
    }],
    // services: [{
    //   value: 0,
    //   label: '免费Wi-Fi'
    // }, {
    //   value: 1,
    //   label: '免费预约'
    // }, {
    //   value: 2,
    //   label: '可送外卖'
    // }, {
    //   value: 3,
    //   label: '免费停车场'
    // }, {
    //   value: 4,
    //   label: '小孩就餐区'
    // }],
    failReason: {
      'buss_not_find': '未查到符合条件的商家',
      'buss_info_not_match': '认领人信息与商家信息不匹配',
      'buss_info_not_right': '商家信息填写有误'
    },
    states: statesOrigin.map((state) => {
      return {
        id: (state || '').toUpperCase(),
        name: state,
        value: state
      }
    }),
    applyType: {
      create: '创建',
      bind: '认领'
    },
    bindStatus: {
      not_bind: '未认领',
      under_review: '审核中',
      approval_fail: '审核未通过',
      binded: '已认领'
    }
  },
  mutations: {},
  getters: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/store.js